import script from "./styleDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./styleDetail.vue?vue&type=script&setup=true&lang=js"

import "./styleDetail.vue?vue&type=style&index=0&id=d22fe9a8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d22fe9a8"]])

export default __exports__